import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import RecruiterProfileCreate from "./components/create-profile";
import CongratsStep from "./components/congrats";
import styled from "styled-components";
import { ToastContext } from "../../services/contexts/toast-context";
import { useCreateRecruiter, useGetRecruiterProfile } from "../../services/api/recruiter-api";
import Loading from '../../components/loading';

const Container = styled.div`
  min-height: 100vh;
  padding: 4rem 1rem;
  background: var(--bg-main);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  font-family: inherit;
`;

export default function OnBoardingRecruiter() {
  const [step, setStep] = useState(1);
  const navigate = useNavigate();
  const { mutate: createRecruiter, isPending: isCreating } = useCreateRecruiter();
  const { data: recruiterProfile, isLoading: profileLoading } = useGetRecruiterProfile();

  const toastRef = useContext(ToastContext);

  // ✅ If recruiter profile exists, redirect to dashboard
  useEffect(() => {
    if (!profileLoading && recruiterProfile) {
      navigate("/recruiter/home", { replace: true }); // prevents going back to onboarding
    }
  }, [profileLoading, recruiterProfile, navigate]);

  const handleProfileSave = async (formData) => {
    createRecruiter(formData, {
      onSuccess: () => {
        toastRef.current.show({
          severity: "success",
          summary: "Success",
          detail: "Profile created successfully",
          life: 5000,
        });
        setStep(2);
      },
      onError: (error) => {
        toastRef.current.show({
          severity: "error",
          summary: "Error",
          detail: JSON.stringify(error.response?.data?.error || error.message),
          life: 3000,
        });
      },
    });
  };

  const handleBuyMore = () => {
    navigate("/purchase?type=credit");
  };

  const handleExploreFeatures = () => {
    navigate("/recruiter/home");
  };

  // ✅ While loading profile, don't show onboarding
  if (profileLoading) {
    return <div><Loading /></div>;
  }

  return (
    <Container>
      {step === 1 && (
        <RecruiterProfileCreate
          loading={isCreating}
          onSave={handleProfileSave}
          onBack={() => navigate('/')}
        />
      )}
      {step === 2 && (
        <CongratsStep
          onBuyMore={handleBuyMore}
          onExploreFeatures={handleExploreFeatures}
        />
      )}
    </Container>
  );
}
